import { OrmModel, StringField, BooleanField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.AUTOMATION_LOG_PREVIEW)
export default class AutomationLogPreview extends BaseModel {
  @StringField()
  public name: string

  @BooleanField()
  public isDeleted: boolean
}
